import React from 'react';
import { Link } from 'react-router-dom';

// IKATone Logo Component
export const Logo = ({ size = 'default', showText = true, className = '' }) => {
  const sizes = {
    small: { icon: 'w-6 h-6', text: 'text-lg' },
    default: { icon: 'w-8 h-8', text: 'text-xl' },
    large: { icon: 'w-10 h-10', text: 'text-2xl' },
    xlarge: { icon: 'w-12 h-12', text: 'text-3xl' }
  };

  const s = sizes[size] || sizes.default;

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <div className={`${s.icon} bg-[#0A2540] rounded-xl flex items-center justify-center shadow-lg`}>
        <svg viewBox="0 0 24 24" className="w-3/4 h-3/4" fill="none">
          <path 
            d="M12 2L2 7L12 12L22 7L12 2Z" 
            stroke="white" 
            strokeWidth="1.5" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          />
          <path 
            d="M2 17L12 22L22 17" 
            stroke="white" 
            strokeWidth="1.5" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          />
          <path 
            d="M2 12L12 17L22 12" 
            stroke="white" 
            strokeWidth="1.5" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          />
        </svg>
      </div>
      {showText && (
        <span className={`font-heading font-bold ${s.text} text-white`}>
          IKATone
        </span>
      )}
    </div>
  );
};

// Logo with link
export const LogoLink = ({ size = 'default', showText = true, className = '' }) => {
  return (
    <Link to="/" className={className} data-testid="logo-link">
      <Logo size={size} showText={showText} />
    </Link>
  );
};

// White version for dark backgrounds
export const LogoWhite = ({ size = 'default', showText = true, className = '' }) => {
  const sizes = {
    small: { icon: 'w-6 h-6', text: 'text-lg' },
    default: { icon: 'w-8 h-8', text: 'text-xl' },
    large: { icon: 'w-10 h-10', text: 'text-2xl' },
    xlarge: { icon: 'w-12 h-12', text: 'text-3xl' }
  };

  const s = sizes[size] || sizes.default;

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <div className={`${s.icon} bg-[#00C48C] rounded-xl flex items-center justify-center`}>
        <svg viewBox="0 0 24 24" className="w-3/4 h-3/4" fill="none">
          <path 
            d="M12 2L2 7L12 12L22 7L12 2Z" 
            stroke="white" 
            strokeWidth="1.5" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          />
          <path 
            d="M2 17L12 22L22 17" 
            stroke="white" 
            strokeWidth="1.5" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          />
          <path 
            d="M2 12L12 17L22 12" 
            stroke="white" 
            strokeWidth="1.5" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          />
        </svg>
      </div>
      {showText && (
        <span className={`font-heading font-bold ${s.text} text-white`}>
          IKATone
        </span>
      )}
    </div>
  );
};

export default Logo;
